import Vue from 'vue'
import Router from 'vue-router'
import TemplateList from '@/components/template-list/template-list'
import CreateActivity from '@/components/create-activity/create-activity'
import ActivityList from '@/components/activity-list'
import PropList from '@/components/prop-list/prop-list'
import SonPropList from '@/components/sonprop-list/sonprop-list'		//分媒体弹层数据组件
import ModelProp from '@/components/modelprop/modelprop'				//弹层模板组件
import CreateProp from '@/components/create-prop/create-prop'		   //已创建弹层组件
import ExposureProp from '@/components/exposure-prop/exposure-prop'    //曝光弹层组件

import SonBuoyList from '@/components/sonbuoy-list/sonbuoy-list'		//浮标分媒体数据组件
import ModelBuoy from '@/components/modelbuoy/modelbuoy'				//浮标模板库组件
import CreateBuoy from '@/components/create-buoy/create-buoy'		//已创建浮标组件
import EditBouy from '@/components/edit-buoy/edit-buoy'    			//浮标编辑组件

import ModelMeeting from '@/components/modelmeeting/modelmeeting'    //会场模板库
import EditMeeting from '@/components/editmeeting/editmeeting'    //会场编辑组件
import CreateMeeting from '@/components/create-meeting/create-meeting'    //已创建会场组件
import SonMeetingList from '@/components/sonmeeting-list/sonmeeting-list' 	  //分会场数据
import SonMeetingAcList from '@/components/sonmeeting-list/sonmettingAc-list.vue'     //会场分活动数据
Vue.use(Router)
 

const router = new Router({
  routes: [
    {
      path: '/',
      redirect: '/template_list'
    },
    // 模板列表
    {
      path: '/template_list',
      name: 'template_list',
      component: TemplateList
    },
    // 创建活动
    {
      path: '/create_activity/:activity_id/:template_id',
      name: 'create_activity',
      component: CreateActivity
    },
    // 活动列表
    {
      path: '/activity_list',
      name: 'activity_list',
      component: ActivityList
    },
// 		弹层数据
//		{
//    path: '/propList',
//    name: 'propList',
//    component: PropList
// 	},
   	// 		分媒体弹层数据
	{
      path: '/LayerSourceView',
      name: 'sonpropList',
      meta: {
       title: '弹层分媒体数据'
      },
      component: SonPropList
    },
    // 		弹层模板库
	{
      path: '/modelprop',
      name: 'modelprop',
      meta: {
       title: '弹层模板'
      },
      component: ModelProp
    },
   // 		已创建弹层
	{
      path: '/createprop',
      name: 'createprop',
      meta: {
       title: '已创建弹层'
      },
      component: CreateProp
    },
   // 		曝光弹层
	{
      path: '/exposureprop/:activity_id/:template_id/:types_id',
      name: 'exposureprop',
      meta: {
       title: '曝光弹层'
      },
      component: ExposureProp
    },
     // 		浮标分媒体数据
	{
      path: '/BuoySourceView',
      name: 'BuoySourceView',
      meta: {
       title: '浮标分媒体数据'
      },
      component: SonBuoyList
    },
     // 		浮标模板库
	{
      path: '/modelbuoy',
      name: 'modelbuoy',
      meta: {
       title: '浮标模板库'
      },
      component: ModelBuoy
    },
     // 		已创建浮标
	{
      path: '/createbuoy',
      name: 'createbuoy',
      meta: {
       title: '已创建浮标'
      },
      component: CreateBuoy
    },
     // 		浮标编辑
	{
      path: '/editbouy/:activity_id/:template_id',
      name: 'editbouy',
      meta: {
       title: '编辑浮标'
      },
      component: EditBouy
    },
    // 		会场模板
	{
      path: '/modelmeeting',
      name: 'modelmeeting',
      meta: {
       title: '会场模板'
      },
      component: ModelMeeting
    },
    //      会场编辑
    {
      path: '/editmeeting/:activity_id/:template_id/:TempName',
      name: 'editmeeting',
      meta: {
       title: '编辑会场'
      },
      component: EditMeeting
    },
//  	已创建会场
    {
      path: '/createmeeting',
      name: 'createmeeting',
      meta: {
       title: '已创建会场'
      },
      component: CreateMeeting
    },
    //  	分会场数据
    {
      path: '/ConferenceSourceStatis',
      name: 'ConferenceSourceStatis',
      meta: {
       title: '分会场数据'
      },
      component: SonMeetingList
    },
//  会场分活动数据  
	{
      path: '/ConferenceActivitySourceStatis',
      name: 'ConferenceActivitySourceStatis',
      meta: {
       title: '会场场分活动数据'
      },
      component: SonMeetingAcList
    }
  ]
})
router.beforeEach((to, from, next) => {//beforeEach是router的钩子函数，在进入路由前执行
  if (to.meta.title) {//判断是否有标题
    document.title = to.meta.title
  }
  next()//执行进入路由，如果不写就不会进入目标页
})
export default router


// WEBPACK FOOTER //
// ./src/router/index.js